import React, { useState, useEffect } from 'react';
import { number, func, instanceOf } from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

import { setSurveyInfo } from '../../../actions/turnkeyOmnibusActions';
import { _calculateSampleSize, _calculateCost } from '../../../util/IEUtils';

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: '#828282',
    boxShadow: theme.shadows[1],
    maxWidth: 262,
    fontSize: 12,
    fontFamily: 'inherit',
    padding: 14,
  },
}))(Tooltip);

const SampleSizes = ({
  requiredCompletes,
  setSurveyInfo,
  samplewgtd,
  completesEstimate,
  incidenceRate,
}) => {
  const [value, setRequiredCompletes] = useState(String(requiredCompletes));

  useEffect(
    () => {
      setRequiredCompletes(String(requiredCompletes));
    },
    [requiredCompletes]
  );

  const handleOnChange = ({ target }) => {
    const val = target.value;
    const validatedValue = Number(val) ? val : '';
    setRequiredCompletes(validatedValue);
  };

  const handleOnBlur = () => {
    const sampleSize = _calculateSampleSize(
      Number(value),
      samplewgtd,
      completesEstimate
    );
    setRequiredCompletes(String(sampleSize));
    const estimatedCost = _calculateCost(incidenceRate, sampleSize);
    setSurveyInfo({ requiredCompletes: sampleSize, estimatedCost });
  };

  const inalidValue = value < 1000;

  return (
    <div className="ie--target--samples">
      <h4 className="ie--target--samples--title">
        <span>Sample Size (# of Completes)</span>
        <HtmlTooltip
          title={
            <React.Fragment>
              Based on your targeting criteria, we have suggested number of
              completions to ensure confidence in the fusion of the data. This
              is the minimum number of completes we require to complete the
              processing of data and project it to the US population. You can
              always increase the number of completes to facilitate deeper
              profiling and analysis of your Turn-Key Omnibus.
            </React.Fragment>
          }
          placement="bottom-start"
        >
          <span className="ie--target--ir--tooltip">
            <svg
              className="MuiSvgIcon-root jss92"
              focusable="false"
              viewBox="0 0 24 24"
              aria-hidden="true"
              tabIndex="-1"
              title="Info"
              fill="#94a2b7"
              height="15px"
              width="15px"
            >
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
            </svg>
          </span>
        </HtmlTooltip>
      </h4>
      <div
        className={`ie--target--samples--box ${
          inalidValue ? 'ie--target--samples--box--invalid ' : ' '
        }`}
      >
        <div className="ie--target--samples--input-group">
          <input
            className="ie--target--samples--input"
            type="text"
            value={value}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
          />
          <span>#</span>
        </div>
        {inalidValue && (
          <div className="error">
            You have selected a very niche target. Please relax the targeting
            criteria to proceed
          </div>
        )}
      </div>
    </div>
  );
};

SampleSizes.propTypes = {
  requiredCompletes: number,
  setSurveyInfo: func,
  samplewgtd: instanceOf(Object),
  completesEstimate: number,
  incidenceRate: number.isRequired,
};

SampleSizes.defaultProps = {
  requiredCompletes: 2000,
  completesEstimate: null,
  samplewgtd: null,
  incidenceRate: 100,
};

const mapStateToProps = ({ turnkeyOmnibus }) => ({
  requiredCompletes: turnkeyOmnibus.surveyInfo.requiredCompletes,
  samplewgtd: turnkeyOmnibus.samplewgtd,
  completesEstimate: turnkeyOmnibus.completesEstimate,
  incidenceRate: turnkeyOmnibus.surveyInfo.incidenceRate,
});

export default connect(
  mapStateToProps,
  { setSurveyInfo }
)(SampleSizes);
